import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { titles } from '../../../environments/titles';

@Injectable({
  providedIn: 'root'
})
export class TitleService {

  protected constructor (
    private readonly _angularTitleService: Title,
    private readonly _router: Router
  ) {}

  public populate(): void {
    this.applyTitle(this._router.url);
    this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.applyTitle(event.urlAfterRedirects);
      }
    });
  }

  private applyTitle(rawUrl: string): void {
    const tree = this._router.parseUrl(rawUrl);
    const segments = (tree.root.children['primary']?.segments ?? [])
      .map(s => s.path)
      .filter(path => path !== '' && !/^\d+$/.test(path));
    const pathKey = segments.join('-');
    const orderType = tree.queryParams['orderType'] || tree.queryParams['type'];
    const keyed = orderType ? `${pathKey}-${orderType}` : pathKey;
    const page = titles[keyed] ?? titles[pathKey];
    this._angularTitleService.setTitle(
      page ? `${page} | ${environment.appName}` : environment.appName
    );
  }
}
